<template>
  <div class="animated fadeIn">
    <b-row class="text-center h5 my-4">
      <b-col v-for="(step, index) in steps" :key="index"><router-link :to="'/submissions/add/step/'+(index+1)">{{step}}</router-link></b-col>
    </b-row>
    <b-progress :value="progressValue" :max="progressMax"></b-progress>
  </div>
</template>

<script>
  export default {
    name: 'SubmissionNav',
    props: ['step'],
    data() {
      return {
        steps: ['Type','Package','Sample(s)','Review'],
        firstStep: 1,
        lastStep: 4,
        progressValue: 0,
        progressMax: 100,
      }
    },
    computed: {},
    methods: {
      getStepPercent() {
        return (+(this.step) - 1) / (this.lastStep - 2);
      },
      getProgressValue() {
        let current = +(this.step);
        let first = +(this.firstStep);
        let last = +(this.lastStep);
        if(current <= first) {
          return 12;
        } else if(current >= last) {
          return 90;
        }
        return 8 + (54 * this.getStepPercent());
      },
      isActive(step) {
        return (+(step) === +(this.step));
      },
    },
    watch: {
      step() {
        this.progressValue = this.getProgressValue();
      }
    },
    mounted() {
      this.progressValue = this.getProgressValue();
    }
  }
</script>
